import Vue from "vue";
Vue.prototype.$bus = new Vue();

//Message
//vm.$bus.$emit('message:push', message, status)
//message(String): 訊息內容
//status(string): Alert 樣式內容

//購物車 icon 更新狀態
//vm.$bus.$emit('updateCart');



// WEBPACK FOOTER //
// ./src/bus.js